import React from 'react';
import Layout from '../../Layout/Layout';
import TitleBar from '../../Layout/TitleBar';
import WearablesDashboardContainer from './WearablesDashboardContainer';

const WearablesDashboardPage: React.FC = () => {
  return (
    <Layout>
      <TitleBar showBackBtn={false}>Wearables Dashboard</TitleBar>
      <section className="page-template-wearables-dashboard full-height3a">
        <WearablesDashboardContainer />
      </section>
    </Layout>
  );
};

export default WearablesDashboardPage;
